import React from 'react';
import { Option, SelectWithAddItemOption } from '../../../../../components/Input';
import { translations } from '../../../../../utils/LocalizedStrings';
import { useFormDataContext } from '../../../contexts/form-data.ctx';

function PlnomocenstvoHeaderComponent({
  documentId,
  name,
  label = 'Select',
  ...rest
}) {
  const values = useFormDataContext(({ data, setField }) => ({
    prokuristi: data.company.prokuristi,
    konatelia: data.company.konatelia,
    likvidatori: data.company.likvidatori,
    custom: [],
    value: data["plnomocenstvo_header_custom"] || [],
    setField,
  }));

  const [fieldValues, setFieldValues] = React.useState(values);
  const [value, setValue] = React.useState("");
  const [, updateState] = React.useState({});
  const forceUpdate = React.useCallback(() => updateState({}), []);


  const handleChange = (value) => {
    fieldValues.value = value
    values.setField({
      target: {
        name,
        value: fieldValues.value
      },
    });
    forceUpdate()
  }

  const addItem = (value) => {
    let valuesToSet = fieldValues
    valuesToSet.custom.unshift({ fullName: value, address: "" })
    setFieldValues(valuesToSet)
    forceUpdate()
  };

  return (
    <>
      <SelectWithAddItemOption
        onFocus={rest.onFocus}
        onBlur={rest.onBlur}
        addItem={addItem}
        label={translations.artifacts.PlnomocenstvoHeader.enterFullOwner}
        name={name}
        multi={"multiple"}
        onChange={handleChange}
        placeholder={translations.artifacts.PlnomocenstvoHeader.enterFullOwner}
        stringValues={[]}
        value={fieldValues.value}>
        {fieldValues?.konatelia?.map((konatel) => (
          <Option value={konatel.personName.formatedName + ", konateľ"} key={`${documentId}_${konatel.personName.formatedName}`}>
            {konatel.personName.formatedName + ", konateľ"}
          </Option>
        ))}
        {fieldValues?.prokuristi?.map((prokurista) => (
          <Option value={prokurista.personName.formatedName + ", prokurista"} key={`${documentId}_${prokurista.personName.formatedName}`}>
            {prokurista.personName.formatedName + ", prokurista"}
          </Option>
        ))}
        {fieldValues?.likvidatori?.map((likvidator) => (
          <Option value={likvidator.personName.formatedName + ", likvidátor"} key={`${documentId}_${likvidator.personName.formatedName}`}>
            {likvidator.personName.formatedName + ", likvidátor"}
          </Option>
        ))}
        {fieldValues?.custom?.map((customValue) => (
          <Option value={customValue.personName.formatedName} key={`${documentId}_${customValue.personName.formatedName}`}>
            {customValue.personName.formatedName}
          </Option>
        ))}
      </SelectWithAddItemOption>
    </>
  );
}

function PlnomocenstvoHeaderHTMLRenderer(values) {
  let returnValue = '';
  if (
    values &&
    values['plnomocenstvo_header_custom'] &&
    Array.isArray(values['plnomocenstvo_header_custom'])
  ) {
    if (values['plnomocenstvo_header_custom'].length > 1) {
      returnValue += "konajúce osoby: "
    } else {
      returnValue += "konajúca osoba: "
    }
    let index = 0;
    for (let representingPerson of values['plnomocenstvo_header_custom']) {
      if (index + 1 === values['plnomocenstvo_header_custom'].length) {
        returnValue += representingPerson
      } else {
        returnValue += `${representingPerson}, `
      }
      index += 1;
    }
  }

  if (returnValue !== '') {
    return returnValue
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  Mutator: PlnomocenstvoHeaderComponent,
  HTMLRenderer: PlnomocenstvoHeaderHTMLRenderer,
};
